module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Kinvey/js-sdk/node_modules/promise-queue/index.js
// module id = 405
// module chunks = 0